import { PaginationEllipses } from '@vp/swan';
import { generatePageNumbers, showEllipses } from './paginationHelpers';
import { LEFT, RIGHT } from '../../constants/pagination';
import { usePaginationContext } from '../contexts/PaginationContext';

type PaginationStepsProps = {
  currentPage: number;
  createPaginationStep: (pageNumber: number) => void;
};

export const PaginationSteps = ({
  currentPage,
  createPaginationStep,
}: PaginationStepsProps) => {
  const { totalPageCount } = usePaginationContext();

  const pageNumbers = generatePageNumbers(currentPage, totalPageCount);

  // left ellipses appear after first page number, and before middle three page numbers
  const beforePageRange = showEllipses(totalPageCount, LEFT, currentPage) ? (
    <PaginationEllipses key={-1} data-testid="paginationEllipses left" />
  ) : null;

  // right ellipses appear after middle three page numbers and before last page number
  const afterPageRange = showEllipses(
    totalPageCount,
    RIGHT,
    undefined,
    pageNumbers
  ) ? (
    <PaginationEllipses key={-2} data-testid="paginationEllipses right" />
  ) : null;

  return (
    <>
      {beforePageRange}
      {pageNumbers.map((pageNumber) => createPaginationStep(pageNumber))}
      {afterPageRange}
    </>
  );
};
